import { render } from "./MyTest.vue?vue&type=template&id=3828452e&scoped=true"
import script from "./MyTest.vue?vue&type=script&lang=js"
export * from "./MyTest.vue?vue&type=script&lang=js"

import "./MyTest.vue?vue&type=style&index=0&id=3828452e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3828452e"]])

export default __exports__